<template>
    <div>
        <x-modal
            :wWidth="1200"
            :wHeight="800"
            :minWidth="1080"
            :maxWidth="1200"
            v-if="isVisible"
            @cancel="closeTenantSettings"
            :draggable="true"
            :resizable="true"
            :hideOk="true"
            cancelText="Close"
        >
            <div slot="title" :class="`d-flex justify-content-between align-items-center`">Tenant Settings</div>

            <div v-if="!_.isEmpty(settings)" class="container settings-container">
                <div class="tenant-section" v-if="menuItems.filter((menuItem) => menuItem.group == 'settings' && menuItem.visible == true).length > 0">
                    <div class="section-title">
                        <h4>General Settings</h4>
                    </div>

                    <el-row :gutter="20">
                        <template v-for="(item, key) in menuItems.filter((menuItem) => menuItem.group == 'settings')">
                            <el-col v-if="item.visible" :key="key" :span="4">
                                <a v-if="item.name == 'Lead Scoring'" rel="noopener" @click="openLeadScoring">
                                    <div ref="quicklink" class="quicklink">
                                        <div class="icon">
                                            <font-awesome-icon :icon="item.icon"/>
                                        </div>
                                        <div class="title">
                                            <h4>{{ item.name }}</h4>
                                        </div>
                                    </div>
                                </a>
                                <a v-else-if="item.name == 'Broker Target'" rel="noopener" @click="openBrokerTarget">
                                    <div ref="quicklink" class="quicklink">
                                        <div class="icon">
                                            <font-awesome-icon :icon="item.icon"/>
                                        </div>
                                        <div class="title">
                                            <h4>{{ item.name }}</h4>
                                        </div>
                                    </div>
                                </a>
                                <a v-else-if="item.name == 'Hide Lead Source and Types'" rel="noopener"
                                   @click="openHideLeadSourceAndTypes">
                                    <div ref="quicklink" class="quicklink">
                                        <div class="icon">
                                            <font-awesome-icon :icon="item.icon"/>
                                        </div>
                                        <div class="title">
                                            <h4>{{ item.name }}</h4>
                                        </div>
                                    </div>
                                </a>
                                <a v-else target="_blank" rel="noopener" :href="item.endpoint">
                                    <div ref="quicklink" class="quicklink">
                                        <div class="icon">
                                            <font-awesome-icon :icon="item.icon"/>
                                        </div>
                                        <div class="title">
                                            <h4>{{ item.name }}</h4>
                                        </div>
                                    </div>
                                </a>
                            </el-col>
                        </template>
                    </el-row>
                </div>

                <div class="tenant-section" v-if="menuItems.filter((menuItem) => menuItem.group == 'reports' && menuItem.visible == true).length > 0">
                    <div class="section-title">
                        <h4>API & Reports</h4>
                    </div>
                    <el-row :gutter="20">
                        <template v-for="(item, key) in menuItems.filter((menuItem) => menuItem.group == 'reports')">
                            <el-col v-if="item.visible" :key="key" :span="4">
                                <a target="_blank" rel="noopener" :href="item.endpoint">
                                    <div ref="quicklink" class="quicklink">
                                        <div class="icon">
                                            <font-awesome-icon :icon="item.icon"/>
                                        </div>
                                        <div class="title">
                                            <h4>{{ item.name }}</h4>
                                        </div>
                                    </div>
                                </a>
                            </el-col>
                        </template>
                    </el-row>
                </div>

                <div class="tenant-section" v-if="menuItems.filter((menuItem) => menuItem.group == 'dashboard' && menuItem.visible == true).length > 0">
                    <div class="section-title">
                        <h4>Dashboard</h4>
                    </div>
                    <el-row :gutter="20">
                        <template v-for="(item, key) in menuItems.filter((menuItem) => menuItem.group == 'dashboard')">
                            <el-col v-if="item.visible" :key="key" :span="4">
                                <a target="_blank" rel="noopener" :href="item.endpoint">
                                    <div ref="quicklink" class="quicklink">
                                        <div class="icon">
                                            <font-awesome-icon :icon="item.icon"/>
                                        </div>
                                        <div class="title">
                                            <h4>{{ item.name }}</h4>
                                        </div>
                                    </div>
                                </a>
                            </el-col>
                        </template>
                    </el-row>
                </div>
            </div>
        </x-modal>

        <lead-scoring-modal
            :lead-scoring="leadScoring"
            :visible.sync="leadScoringModalVisible"
            :sources="sources"></lead-scoring-modal>

        <broker-target
            :visible.sync="brokerTargetVisible"
        >
        </broker-target>

        <hide-lead-source-and-types
            :visible.sync="hideLeadSourceAndTypes">
        </hide-lead-source-and-types>
    </div>
</template>

<script>
import {mapGetters} from "vuex"
import LeadScoringModal from "../LeadManagement/LeadScoringModal";
import BrokerTarget from "../brokerTarget";
import HideLeadSourceAndTypes from "./HideLeadSourceAndTypes";

export default {
    name: "TenantSettingsModal",
    props: {
        user: {
            required: true,
            type: Object,
        },
        rolePermissions: {
            required: true,
            type: Array,
        },
    },
    components: {
        LeadScoringModal,
        BrokerTarget,
        HideLeadSourceAndTypes
    },
    watch: {},
    data() {
        return {
            isVisible: false,
            leadScoringModalVisible: false,
            settings: {},
            dashboard: [],
            leadScoring: [],
            brokerTargetVisible: false,
            hideLeadSourceAndTypes: false
        }
    },
    mounted() {
        this.$bus.$on("toggle-tenant-settings", () => {
            this.isVisible = true
            this.getSettings()
            this.getDashboard()
            this.getLeadScoring()
        })
    },
    activated() {
    },
    computed: {
        ...mapGetters({
            sources: 'options/sources'
        }),
        menuItems() {
            if (!this.user) return []
            return [
                {
                    name: "Tenant Configuration",
                    icon: "images",
                    endpoint: "/admin/settings/logos",
                    visible: Ambition.hasRoleOrPermission(["super administrator", "administrator", "manager"]),
                    group: "settings",
                },
                {
                    name: "User Management",
                    icon: "user",
                    endpoint: "/admin/auth/user",
                    visible: Ambition.hasRoleOrPermission(["administrator"]),
                    group: "settings",
                },
                {
                    name: "Role Management",
                    icon: "lock",
                    endpoint: "/admin/auth/role",
                    visible: Ambition.hasRoleOrPermission(["super administrator", "administrator", "manager"]),
                    group: "settings",
                },
                {
                    name: "Application Categories",
                    icon: "book",
                    endpoint: "/admin/application-categories",
                    visible: Ambition.hasRoleOrPermission(["super administrator", "administrator", "manager"]),
                    group: "settings",
                },
                {
                    name: "Application Audit",
                    icon: "book",
                    endpoint: "/admin/settings/application-audit",
                    visible: this.settings.useApplicationAudits && Ambition.hasRoleOrPermission(["administrator", "view audit"]),
                    group: "settings",
                },
                {
                    name: "Document Library",
                    icon: "book",
                    endpoint: "/admin/settings/document-library",
                    visible: Ambition.hasRoleOrPermission(["super administrator", "administrator", "manager"]),
                    group: "settings",
                },
                {
                    name: "Insurer Documents",
                    icon: "book",
                    endpoint: "/admin/settings/insurance-documents",
                    visible: Ambition.hasRoleOrPermission(["super administrator", "administrator", "manager"]),
                    group: "settings",
                },
                {
                    name: "Email Variables",
                    icon: "envelope-open",
                    endpoint: "/admin/email_variables",
                    visible: !this.settings.useEmailBuilder && Ambition.hasRoleOrPermission(["super administrator", "administrator", "manager"]),
                    group: "settings",
                },
                {
                    name: "Email Templates",
                    icon: "envelope",
                    endpoint: "/admin/settings/email_templates",
                    visible: !this.settings.useEmailBuilder && Ambition.hasRoleOrPermission(["super administrator", "administrator", "manager"]),
                    group: "settings",
                },
                {
                    name: "SMS Templates",
                    icon: "comment-alt",
                    endpoint: "/admin/settings/sms_templates",
                    visible: !this.settings.useEmailBuilder && Ambition.hasRoleOrPermission(["super administrator", "administrator", "manager"]),
                    group: "settings",
                },
                {
                    name: "Email & SMS",
                    icon: "envelope",
                    endpoint: "/admin/settings/email-templates",
                    visible: this.settings.useEmailBuilder && Ambition.hasRoleOrPermission(["super administrator", "administrator", "manager", "marketing manager"]),
                    group: "settings",
                },
                {
                    name: "Dealers",
                    icon: "handshake",
                    endpoint: "/admin/dealers",
                    visible: Ambition.hasRoleOrPermission(["super administrator", "administrator", "manager", "marketing manager"]),
                    group: "settings",
                },
                {
                    name: "Settlement Requirements",
                    icon: "handshake",
                    endpoint: "/admin/settings/settlement_requirement",
                    visible: !this.settings.useApplicationAudits && Ambition.hasRoleOrPermission(["super administrator", "administrator", "manager"]),
                    group: "settings",
                },
                {
                    name: "Custom Fields",
                    icon: "indent",
                    endpoint: "/admin/settings/custom-fields",
                    visible: Ambition.hasRoleOrPermission(["super administrator", "administrator", "manager"]),
                    group: "settings",
                },
                {
                    name: "Digital Ancillaries",
                    icon: "file-archive",
                    endpoint: "/admin/settings/digital-ancillaries",
                    visible: Ambition.hasRoleOrPermission(["super administrator", "administrator", "manager"]),
                    group: "settings",
                },
                {
                    name: "Teams",
                    icon: "user-friends",
                    endpoint: "/admin/settings/team",
                    visible: Ambition.hasRoleOrPermission(["super administrator", "administrator", "manager"]) && _.get(Ambition, 'Globals.tenant.teams_enabled'),
                    group: "settings",
                },
                {
                    name: "Security",
                    icon: "lock",
                    endpoint: "/admin/settings/security",
                    visible: Ambition.hasRoleOrPermission(["super administrator", "administrator", "manager"]),
                    group: "settings",
                },
                {
                    name: "Zapier",
                    icon: "bolt",
                    endpoint: "/admin/settings/zapier",
                    visible: Ambition.hasRoleOrPermission(["super administrator", "administrator", "manager"]),
                    group: "settings",
                },
                {
                    name: "Service Tests",
                    icon: "fa-life-ring",
                    endpoint: "/admin/settings/services-tests",
                    visible: Ambition.hasRoleOrPermission(["super administrator", "administrator", "manager"]),
                    group: "settings",
                },
                {
                    name: "Lead Scoring",
                    icon: "fa-bar-chart",
                    endpoint: '',
                    visible: Ambition.hasRoleOrPermission(["super administrator", "administrator", "manager"]),
                    group: "settings",
                },
                {
                    name: "Broker Target",
                    icon: "fa-bullseye",
                    endpoint: '',
                    visible: Ambition.hasRoleOrPermission(["super administrator", "administrator", "manager"]),
                    group: "settings",
                },
                {
                    name: "Hide Lead Source and Types",
                    icon: "fa-file-text",
                    endpoint: '',
                    visible: Ambition.hasRoleOrPermission(["super administrator", "administrator", "manager"]),
                    group: "settings",
                },
                {
                    name: "Accounting / Xero",
                    icon: "bolt",
                    endpoint: "/admin/xero",
                    visible: Ambition.hasRoleOrPermission(["super administrator", "administrator", "manager"]),
                    group: "reports",
                },
                {
                    name: "External API Config",
                    icon: "ethernet",
                    endpoint: "/admin/settings/external-api-config",
                    visible: Ambition.hasRoleOrPermission(["super administrator", "administrator", "manager"]),
                    group: "reports",
                },
                {
                    name: "Logs",
                    icon: "bug",
                    endpoint: "/admin/settings/log-viewer/logs",
                    visible: Ambition.hasRoleOrPermission(["super administrator", "administrator", "manager"]),
                    group: "reports",
                },
                {
                    name: "Loan API Reports",
                    icon: "file-archive",
                    endpoint: "/admin/v2/loan-api-requests/dashboard",
                    visible: Ambition.hasRoleOrPermission(["super administrator", "administrator", "manager"]),
                    group: "reports",
                },
                {
                    name: "Equifax Reports",
                    icon: "file-archive",
                    endpoint: "/admin/v2/reports",
                    visible: Ambition.hasRoleOrPermission(["super administrator", "administrator", "manager"]),
                    group: "reports",
                },
                {
                    name: "Latitude Reports",
                    icon: "file-archive",
                    endpoint: "/admin/v2/latitude/dashboard",
                    visible: Ambition.hasRoleOrPermission(["super administrator", "administrator", "manager"]),
                    group: "reports",
                },
                {
                    name: "Pepper Requests",
                    icon: "file-archive",
                    endpoint: "/admin/v2/pepper/requests",
                    visible: Ambition.hasRoleOrPermission(["super administrator", "administrator", "manager"]),
                    group: "reports",
                },
                {
                    name: "Liberty Reports",
                    icon: "file-archive",
                    endpoint: "/admin/v2/liberty/dashboard",
                    visible: Ambition.hasRoleOrPermission(["super administrator", "administrator", "manager"]),
                    group: "reports",
                },
                {
                    name: "Money3 Reports",
                    icon: "file-archive",
                    endpoint: "/admin/v2/money3/dashboard",
                    visible: Ambition.hasRoleOrPermission(["super administrator", "administrator", "manager"]),
                    group: "reports",
                },
                {
                    name: "Macquarie Reports",
                    icon: "file-archive",
                    endpoint: "/admin/v2/macquarie/dashboard",
                    visible: Ambition.hasRoleOrPermission(["super administrator", "administrator", "manager"]),
                    group: "reports",
                },
                {
                    name: "Inbound API Reports",
                    icon: "file-archive",
                    endpoint: "/admin/v2/inbound-api-requests/dashboard",
                    visible: Ambition.hasRoleOrPermission(["super administrator", "administrator", "manager"]),
                    group: "reports",
                },
                {
                    name: "Applications Access Logs",
                    icon: "bug",
                    endpoint: "/admin/v2/applications-access-logs",
                    visible: Ambition.hasRoleOrPermission(["super administrator", "administrator", "manager"]),
                    group: "reports",
                },

                // Dashboard
                {
                    name: "CREATE DASHBOARD",
                    icon: "plus",
                    endpoint: "/admin/settings/dashboard/create",
                    visible: Ambition.hasRoleOrPermission(["super administrator", "administrator", "manager"]),
                    group: "dashboard",
                },
                {
                    name: "EDIT DASHBOARDS",
                    icon: "pen",
                    endpoint: "/admin/settings/dashboard/index",
                    visible: this.dashboard.length > 0 && Ambition.hasRoleOrPermission(["super administrator", "administrator", "manager"]),
                    group: "dashboard",
                },
                {
                    name: "MERGED DASHBOARDS",
                    icon: "compress",
                    endpoint: "/admin/settings/merged-dashboards",
                    visible: Ambition.hasRoleOrPermission(["super administrator", "administrator", "manager"]),
                    group: "dashboard",
                },
            ]
        },
    },
    methods: {
        closeTenantSettings() {
            this.isVisible = false
            this.$emit("update:visible", false)
        },
        getLeadScoring() {
            this.$tenant
                .get(`/api/lead-management/lead-scoring`).then((res) => {
                this.leadScoring = _.get(res.data, 'leadScoring')
                this.$store.dispatch("options/saveSources", _.get(res.data, 'sources'))
                this.$store.dispatch("options/saveSourceDetails", _.get(res.data, 'sourceDetails'))
                this.$store.dispatch("options/saveResidentialStatuses", _.get(res.data, 'residentialStatuses'))
                this.$store.dispatch("options/saveLoanTypes", _.get(res.data, 'loanTypes'))
            })
        },
        getSettings() {
            axios
                .post("/admin/settings/get-settings")
                .then((res) => {
                    this.settings = res.data
                })
                .catch((err) => {
                    console.error(err)
                })
        },
        getDashboard() {
            axios
                .get("/admin/settings/get-dashboard")
                .then((res) => {
                    this.dashboard = res.data
                })
                .catch((err) => {
                    console.error(err)
                })
        },
        openLeadScoring() {
            this.leadScoringModalVisible = true
        },
        openBrokerTarget() {
            this.brokerTargetVisible = true
        },
        openHideLeadSourceAndTypes() {
            this.hideLeadSourceAndTypes = true
        }
    },
}
</script>

<style lang="scss" scoped>
.settings-container {
    padding: 20px;

    .tenant-section {
        border: 1px solid #dbdfe6;
        padding: 20px;
        border-radius: 5px;
        margin-bottom: 20px;
        background: #ffffff;
        box-shadow: 0 0 10px 0 rgba(212, 212, 212, 0.3);
        transition: all 0.6s ease;

        &:hover {
            box-shadow: 0 0 10px 0 rgba(212, 212, 212, 1);
            transition: all 0.6s ease;
        }

        .section-title {
            h4 {
                text-transform: uppercase;
                margin-bottom: 30px !important;
                padding-bottom: 10px;
                border-bottom: 1px solid #dbdfe6;
            }
        }
    }
}

.quicklink {
    height: 140px;
    box-shadow: 0 0 5px 1px rgba(36, 43, 70, 0.1);
    transition: all 0.6s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 10px;
    text-align: center;
    border-radius: 5px;
    margin-bottom: 20px;

    .icon {
        font-size: 18px;
        margin-bottom: 10px;
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .title {
        h4 {
            color: #242b46 !important;
            text-transform: uppercase;
            font-weight: 500 !important;
        }
    }

    &:hover {
        box-shadow: 0 0 10px 1px rgba(36, 43, 70, 0.5);
        transition: all 0.6s ease;
    }
}
</style>
